import { render, staticRenderFns } from "./LegalInformation.vue?vue&type=template&id=2859811f&scoped=true&"
import script from "./LegalInformation.vue?vue&type=script&lang=js&"
export * from "./LegalInformation.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/forms.css?vue&type=style&index=0&id=2859811f&scoped=true&lang=css&"
import style1 from "./LegalInformation.vue?vue&type=style&index=1&id=2859811f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2859811f",
  null
  
)

export default component.exports